<template>
    <div class="card config-wrapper">
        <div  class="row">
            <div class="card-header col-12 mt-3">
                <h5 class="card-title text-center">Configurator</h5>
                <hr>
            </div>
        </div>
        <div class="row">
            <div class="col-6 border-right">
                <div class="card-body">
                        <!-- <div class="thumbnail-wrapper">
                            <img v-if="!thumbnailURL" src="@/assets/SmartSalesLogo.png">
                            <img v-if="thumbnailURL" :src="thumbnailURL" class="image" alt="Selected Product Image">
                        </div> -->
                    <LogoDropdown :key="selectedConfiguratorId" @change="handleSelectedConfigChange" v-model="selectedConfiguratorId" :configurators="configuratorOptions"/>

                    <div class="my-3">
                        <div class="form-group">

                            <select class="form-control"
                                    @change="handleMemberSelected"
                                    v-model="selectedMemberId">
                                <option v-for="item in memberOptions" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label><b>Category</b></label>
                        <div class="form-group">
                            <select class="form-control"
                                    v-model="selectedCategoryId"
                                    @change="getConfiguratorProducts"
                                    :disabled="selectedMemberId === null">
                                <option v-for="item in configuratorCategoryOptions" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>

                    <div class="configurator-group-wrapper">
                        <div class="px-2 mb-1 group-container" v-for="group in configuratorProducts" :key="group.Id">
                            <b>{{group.Name}}</b>
                            <div class="px-3 mx-0 mb-1 product-container pointer" @click="handleProductClicked(product)" v-for="(product, index) in group.Products" :key="product + product.Id + index" >
                                {{product.Description}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card-body">
                    <div class="configurator-name-wrapper d-flex align-items-center justify-content-center">
                        <b style="fontSize: 36px">{{capitalize(configuratorName)}}</b>
                        <p>Author: {{configuratorAuthorName}} </p>
                    </div>


                    <div class="product-datagrid-wrapper">
                        <ConfiguratorDataGrid :key="dataSourceUpdateKey" @orderlineUpdateComplete="handleAddProducts" @checkAndUpdateChildRowsQuantity="checkAndUpdateChildRowsQuantity" :addToOrderlinesWasClicked="addToOrderlinesWasClicked" :dataSource="dataSource"></ConfiguratorDataGrid>
                    </div>
                    <div class="row p-2 mx-2 justify-content-between align-items-center">
                        <div ><b class="total">Total:</b></div>
                        <div>{{formatCurrency(totalRetail)}}</div> 
                    </div>
                    <div class="row">
                        <div @click="clearDataSource()" class="btn btn-secondary col btn-block m-2">Start Over</div>
                        <div @click="handleAddToOrderlinesClicked" class="btn btn-secondary col btn-block m-2">Add To Order</div> 
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState }   from 'vuex';
    import { DealerService }  from '@/services';
    import ConfiguratorDataGrid   from '@/components/ConfiguratorDataGrid';
    import LogoDropdown  from '@/components/LogoDropdown';
    // import { DealerService } from '../services';

    export default {
        name: "Configurator",

        components: {
           ConfiguratorDataGrid,
           LogoDropdown,
        },
        data: () => {
            return {
                secondaryGroups: [{group: 'Group1', products:['Prod1', 'Prod2']}, {group: 'Group2', products: ['ProdA', 'ProdB']}],
                configurators: [],
                dataSource: [],
                dataSourceUpdateKey: 0,
                addToOrderlinesWasClicked: false,
                configuratorProducts: [],
                selectedCategoryId: null,
                selectedMemberId: null,
                selectedConfiguratorId: null,
                thumbnailURL: null,
            }
        },
        computed: {
            ...mapState(['currentUser']),
            totalRetail(){
                let total = 0;
                this.dataSource.forEach(item => {
                    if(!item.RetailAmount) return;
                    total += item.RetailAmount * item.Quantity;
                })
                return total;
            },
            configuratorOptions(){
                let options = this.configurators.map(config => {
                    return  {
                            Id: config.Id,
                            ConfiguratorName: config.ConfiguratorName,
                            ConfiguratorLogoUrl: config.ConfiguratorLogoUrl
                        }
                })
                return options.sort(function(a, b) {
                    var textA = a.ConfiguratorName.toUpperCase();
                    var textB = b.ConfiguratorName.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });

            },
            memberOptions(){
                let index = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId);
                if (index < 0) return [];
                return this.configurators[index].ConfiguratorMembers.map(member => {
                    return {
                        Id: member.Id,
                        Name: member.Name,
                        AuthorName: member.AuthorName
                    }
                })
            },
            configuratorCategoryOptions(){
                let configuratorIndex = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId);
                if (configuratorIndex < 0) return [];
                let memberIndex = this.configurators[configuratorIndex].ConfiguratorMembers.map(member => member.Id).indexOf(this.selectedMemberId);
                if (memberIndex < 0) return [];
                return this.configurators[configuratorIndex].ConfiguratorMembers[memberIndex].Categories;
            },
            configuratorName(){
                if(!this.selectedConfiguratorId) return "";
                let index = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId)
                if(index < 0) return "";
                return this.configurators[index].ConfiguratorName;
            },
            configuratorAuthorName(){

                if(!this.selectedMemberId) return "";
                let index = this.memberOptions.map(member => member.Id).indexOf(this.selectedMemberId)
                if(index < 0) return "";

                return this.memberOptions[index].AuthorName;
            }
        },
        methods: {
            checkAndUpdateChildRowsQuantity(parentId, quantity){
                this.dataSource.forEach(row => {
                    if(row.parentId && row.parentId === parentId){
                        row.Quantity = quantity * row.parentRatio;
                    }
                })
                
            },
            capitalize(string){
                // console.log(string.charAt(0).toUpperCase() + string.slice(1))
                // return string.charAt(0).toUpperCase() + string.slice(1);
                return string.toUpperCase();
            },
            handleMemberSelected(){
                let configuratorIndex = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId);
                let memberIndex = this.configurators[configuratorIndex].ConfiguratorMembers.map(member => member.Id).indexOf(this.selectedMemberId);
                this.selectedCategoryId = this.configurators[configuratorIndex].ConfiguratorMembers[memberIndex].Categories[0].Id
                this.getConfiguratorProducts();
            },
            handleSelectedConfigChange(){
                let configuratorIndex = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId);
                this.selectedMemberId = this.configurators[configuratorIndex].ConfiguratorMembers[0].Id;
                this.selectedCategoryId = this.configurators[configuratorIndex].ConfiguratorMembers[0].Categories[0].Id
                this.getConfiguratorProducts();
            },
            formatCurrency(currency){
                if(typeof(currency) !== 'number') return;
                return `$${currency.toFixed(2)}`;
            },
            clearDataSource(){
                this.dataSource = [];
                this.dataSourceUpdateKey++;
            },
            handleProductClicked(product){
                this.addProductToConfiguratorDataGrid(product);
            },
            updateQuantityForParentAndChildren(productId){
                let index = this.dataSource.map(row => row.Id).indexOf(productId)
                this.dataSource[index].Quantity++;
                let qty = this.dataSource[index].Quantity;
                this.dataSource.forEach(row => {
                    if(row.parentId === productId){
                        row.Quantity = qty * row.parentRatio;
                    }
                })
            },
            productAlreadyExists(productId){
                return this.dataSource.map(row => row.Id).indexOf(productId) >= 0;
            },
            addProductToConfiguratorDataGrid(product){
                if(this.productAlreadyExists(product.Id)){
                    this.updateQuantityForParentAndChildren(product.Id)
                    return;
                }
                let lineNumber = 0;
                
                this.dataSource.forEach(obj => {
                    if(obj.lineNumber >= lineNumber){
                        lineNumber = obj.lineNumber+1;
                    }
                })
                let productWithoutSubproducts = {...product}
                productWithoutSubproducts.Quantity = productWithoutSubproducts.Quantity || 1 ;
                delete productWithoutSubproducts.Subproducts
                this.dataSource.push({
                    ...productWithoutSubproducts,
                    lineNumber: lineNumber
                }) 
                lineNumber++;
                if(product.Subproducts){
                    product.Subproducts.forEach(Subproduct => {
                        Subproduct.Quantity = Subproduct.Quantity || 1;
                        let parentQuantity = productWithoutSubproducts.Quantity;
                        let childQuantity = Subproduct.Quantity;
                        let parentRatio = childQuantity/parentQuantity;
                        this.dataSource.push({...Subproduct, lineNumber: lineNumber, parentId: productWithoutSubproducts.Id, parentRatio: parentRatio});
                        lineNumber++;
                    })
                }
            },
            getConfigurators(){
                DealerService.configurators().then(res => {
                    this.configurators = res
                    this.selectedConfiguratorId = res[0].Id;
                    this.selectedMemberId = res[0].ConfiguratorMembers[0].Id;
                    this.selectedCategoryId = res[0].ConfiguratorMembers[0].Categories[0].Id
                    this.getConfiguratorProducts();
                }).catch(err => {
                    console.error(err);
                })
            },
            getConfiguratorProducts(){
                this.configuratorProducts = []
                DealerService.configuratorsProducts(this.selectedCategoryId).then(res => {
                    this.configuratorProducts = res;
                }).catch(err => {
                    console.error(err);
                })
            },  
            handleAddToOrderlinesClicked(){
                this.addToOrderlinesWasClicked = true;
            },
            handleAddProducts(){
                this.$emit('productsAdded', this.dataSource)
                this.clearDataSource()
                this.addToOrderlinesWasClicked = false;
            },
        },
        mounted(){
            this.getConfigurators();
        },
    }
</script>

<style scoped lang="scss">
    .config-wrapper{
        max-width: 1200px;
        // min-width: 1000px;
    }
    .image{
        max-width: 150px;
        max-height: 150px
    }
    .icon-btn{
        border: none;
        background-color: transparent;
        padding: 0px;
    }
    .thumbnail-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        min-height: 100px;
    }
    .configurator-name-wrapper{
        display: flex;
        flex-direction: column
    }
    .configurator-group-wrapper{
        background-color: white;
        border: solid 1px $ss-grey2;
        // min-width: 400px;
        // min-height: 450px;
        height: 30vh;
        max-height: 30vh;
        overflow: scroll;
        .group-container:hover{
            background-color: rgba(0,0,0,.05);
        }
        .product-container:hover{
            background-color: $secondary;
        }
    }
    .product-datagrid-wrapper {
        /*max-height: 200px;*/
        padding: 10px;
    }
    .total{
        color: $primary;
        font-size: 28px;
    }
    .form-group{
        margin-bottom: 0px;

        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background:transparent;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            /*background-color: #fff; inherits from form-control*/
            padding-right: 5px;
        }
    }
</style>
